import React from 'react';
const { useTranslation } = require('react-i18next');

export const AuthorizeText = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col text-justify p-4 font-semibold">
      {t('AuthorizeText.text1')}
      <ul className="p-4">
        <li>{t('AuthorizeText.point1')}</li>
        {/* <li>{t('AuthorizeText.point2')}</li> */}
        {/* <li>{t('AuthorizeText.point3')}</li> */}
        <li>{t('AuthorizeText.point4')}</li>
      </ul>
      {t('AuthorizeText.text2')}
    </div>
  );
};
